import { SectionNav } from "./SectionNav";
import { RUN_SLOTS } from "./sections";

// DELIVER — everything we do to find and move candidates while delivering the
// search for the client. Labelled "Deliver" in the UI; the route stays `run`.
// The pipeline-centred execution surface is assembled here (Epic 0 #2218).
export function RunSection() {
  return <SectionNav slots={RUN_SLOTS} ariaLabel="Deliver sections" />;
}
